import {
  rcoPoBoxShipmentSegmentSchema,
  RcoSegmentStep,
} from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const PoBoxShipmentInspectorContent = memo(
  function PoBoxShipmentInspectorContent({ step }: { step: RcoSegmentStep }) {
    const { t } = useTranslation();
    rcoPoBoxShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Condition")}
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {t("Shipping address is a PO box")}
        </Text>
      </Flex>
    );
  },
);

export const EditablePoBoxShipmentInspectorContent = memo(
  function EditablePoBoxShipmentInspectorContent({
    step,
  }: {
    step: Omit<RcoSegmentStep, "matchingNextId" | "nonMatchingNextId"> & {
      matchingNextId?: string | undefined;
      nonMatchingNextId?: string | undefined;
    };
  }) {
    const { t } = useTranslation();
    rcoPoBoxShipmentSegmentSchema.parse(step.segment);

    return (
      <Flex align="flex-start" dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Condition")}
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {t("Shipping address is a PO box")}
        </Text>
      </Flex>
    );
  },
);
